module.exports = __webpack_public_path__ + "media/games-15.496c2d5a.mp4";